import * as React from 'react';
import { ThemeProvider } from 'styled-components';
import { themeMap, ThemeNames } from 'styles/theme';
import GlobalStyles from 'styles/GlobalStyle';

export const ThemeToggleContext = React.createContext({
  theme: ThemeNames.Dark,
  setTheme: (_theme: ThemeNames) => {},
});

const ThemeToggleContextProvider: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const [theme, setTheme] = React.useState(ThemeNames.Dark);

  return (
    <ThemeToggleContext.Provider value={{ setTheme, theme }}>
      {children}
    </ThemeToggleContext.Provider>
  );
};

const Wrapper: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <ThemeToggleContextProvider>{children}</ThemeToggleContextProvider>;
};

const ThemeProviderWrapper: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const { theme } = React.useContext(ThemeToggleContext);
  const themeObject = themeMap[theme];

  return (
    <Wrapper>
      <ThemeProvider theme={themeObject}>
        <>
          <GlobalStyles />
          {children}
        </>
      </ThemeProvider>
    </Wrapper>
  );
};

export default ThemeProviderWrapper;
